// Author: Shubham Sonkar

import React from "react";
import { QueryClientProvider, QueryClient } from "react-query";
import "bootstrap/dist/css/bootstrap.min.css";
import Mui from "./context/Mui";
import Bootstrap from "./context/Bootstrap";
import MyGlobalData from "./context/Global";
import Main from "./setting/Main";
import { ErrorBoundary } from "react-error-boundary";
import Cookies from "js-cookie";
import "./App.css";
import PublicProjectPage from "./PublicProjectPage/PublicProjectPage";
import MaintenancePage from "./components/MaintenancePage/MaintenancePage";



// Create a new instance of QueryClient
export const queryClient = new QueryClient();

const App = () => {
  const [loading, setLoading] = React.useState(true);
  const [isMaintenance, setIsMaintenance] = React.useState(false); // 🔹 Added

  const spinner = document.getElementById("spinner");

  if (spinner) {
    setTimeout(() => {
      spinner.style.display = "none";
      setLoading(false);
    }, 200);
  }

  const HandleErrorBoundry = () => {
    Cookies.remove("user", { path: "/", domain: window.location.hostname });
    Cookies.remove("type", { path: "/", domain: window.location.hostname });
    Cookies.remove("role", { path: "/", domain: window.location.hostname });
    Cookies.remove("username", { path: "/", domain: window.location.hostname });
    Cookies.remove("u_id", { path: "/", domain: window.location.hostname });
    Cookies.remove("token", { path: "/", domain: window.location.hostname });
    Cookies.remove("module_privilege", {
      path: "/",
      domain: window.location.hostname,
    });
    localStorage.setItem("currScreen", "Login");
    window.location.reload(true);
  };

  // Manually extract the slug from the URL
  const path = window.location.pathname;
  const projectSlug = path.startsWith("/") ? path.slice(1).toLowerCase() : "";

  React.useEffect(() => {
    const checkMaintenance = async () => {
      try {
        const res = await fetch(`http://localhost:3003/dynamicFields/status`);
        const data = await res.json();
        if (data.status === "maintenance") {
          setIsMaintenance(true);
        } else {
          setIsMaintenance(false);
        }
      } catch (err) {
        console.error("Error fetching maintenance status:", err);
      }
    };

    checkMaintenance();

    // Optional: recheck every 30 seconds
    const interval = setInterval(checkMaintenance, 30000);
    return () => clearInterval(interval);
  }, []);

  const renderPage = () => {
    if (!projectSlug || projectSlug === "home") {
      return <Main />;
    }
    return <PublicProjectPage projectSlug={projectSlug} />;
  };

  // 🔹 Added: Show MaintenancePage if system is under maintenance
  if (isMaintenance) {
    return <MaintenancePage />;
  }

  return (
    !loading && (
      <QueryClientProvider client={queryClient}>
        <Mui>
          <Bootstrap>
            <MyGlobalData>{renderPage()}</MyGlobalData>
          </Bootstrap>
        </Mui>
      </QueryClientProvider>
    )
  );
};

export default App;
